let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("avYuq")).then(() => parcelRequire('jqi1P'));